import React, { useState, useEffect } from 'react';
import { messaging, db } from '../firebase';
import { getToken } from 'firebase/messaging';
import { doc, updateDoc } from 'firebase/firestore';
import toast from 'react-hot-toast';

const VAPID_KEY = 'BKWd5dTP4iSNHmlg5xygfqhpEZ6lZ1yha409CBqarz3JdPcxCTC1o9-emGiFEqyXRyCnK8BkIoQJSXT-aymUJSg';

const NotificationToggle = ({ user }) => {
  const [loading, setLoading] = useState(false);
  const [isSupported, setIsSupported] = useState(false);
  const [permissionState, setPermissionState] = useState(
    typeof window !== 'undefined' && 'Notification' in window ? Notification.permission : 'default'
  );

  useEffect(() => {
    if (typeof window !== 'undefined' && 'Notification' in window && 'serviceWorker' in navigator && messaging) {
      setIsSupported(true);
    }
  }, []);

  // ★データベース上の設定状態（現在ONになっているか）
  const isEnabledInDB = user?.notificationsEnabled === true;

  const handleToggle = async () => {
    if (!user || !user.userId) return;

    setLoading(true);

    try {
        // 【1】すでにONの場合 ＝ OFF（配信停止）にする処理
        if (isEnabledInDB) {
            await updateDoc(doc(db, 'users', user.userId), {
                notificationsEnabled: false // DBのフラグを折る
            });
            toast.success('通知をOFFにしました');
            setLoading(false);
            return;
        }

        // 【2】OFFの場合 ＝ ON（許可を取って設定）にする処理
        if (!messaging) {
          toast.error('このブラウザは通知機能に対応していません。');
          setLoading(false);
          return;
        }

        const permission = await Notification.requestPermission();
        setPermissionState(permission);
        
        if (permission === 'granted') {
          const token = await getToken(messaging, { vapidKey: VAPID_KEY });
          if (token) {
            await updateDoc(doc(db, 'users', user.userId), {
              fcmToken: token,
              notificationsEnabled: true,
              lastTokenUpdate: new Date().toISOString()
            });
            toast.success('通知設定をONにしました！');
          } else {
            toast.error('トークンの取得に失敗しました');
          }
        } else {
          toast('通知が許可されませんでした。ブラウザの設定から許可してください。');
        }
    } catch (error) {
        console.error('通知設定エラー:', error);
        toast.error('エラーが発生しました: ' + error.message);
    } finally {
        setLoading(false);
    }
  };

  if (!isSupported) {
    return null; 
  }

  return (
    <div className="card" style={{marginTop:'20px', textAlign:'center', padding:'20px', borderLeft:'5px solid #2196F3'}}>
      <div style={{fontSize:'32px', marginBottom:'10px'}}>🔔</div>
      <h3 style={{fontSize:'16px', margin:'0 0 10px 0'}}>プッシュ通知設定</h3>
      <p style={{fontSize:'12px', color:'#666', textAlign:'left', marginBottom:'15px', lineHeight:'1.5'}}>
        イベントの作成や変更などの重要なお知らせをスマホにお届けします。<br/>
        <span style={{color:'#d32f2f', fontSize:'10px'}}>※iPhoneの方は「ホーム画面に追加」したアプリから設定してください。</span>
      </p>
      
      <button 
        onClick={handleToggle} 
        disabled={loading}
        className="btn"
        style={{
          // ★ONの時は赤色(OFFにする)、OFFの時は青色(ONにする)
          background: isEnabledInDB ? '#f44336' : '#2196F3', 
          color: 'white', 
          fontWeight: 'bold',
          width: '100%',
          padding: '12px',
          opacity: loading ? 0.7 : 1,
          boxShadow: '0 2px 5px rgba(0,0,0,0.2)'
        }}
      >
        {loading ? '処理中...' : (isEnabledInDB ? '通知を停止する (OFF)' : '通知を受け取る (ON)')}
      </button>
      
      {/* 状態をテキストでも表示 */}
      {isEnabledInDB ? (
          <div style={{fontSize:'11px', color:'#4caf50', marginTop:'10px', fontWeight:'bold'}}>✅ 現在、通知は【ON】です</div>
      ) : (
          <div style={{fontSize:'11px', color:'#999', marginTop:'10px'}}>🔕 現在、通知は【OFF】です</div>
      )}
    </div>
  );
};

export default NotificationToggle;